var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnknown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 160,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 159V1H95.5858L119 24.4142V159H1Z",
    fill: "white",
    stroke: "#1A237E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 2V24H118",
    stroke: "#1A237E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 46.6667C41.6001 46.6667 26.6667 61.6 26.6667 80C26.6667 98.4 41.6001 113.333 60.0001 113.333C78.4001 113.333 93.3334 98.4 93.3334 80C93.3334 61.6 78.4001 46.6667 60.0001 46.6667ZM63.3334 103.333H56.6667V96.6667H63.3334V103.333ZM70.2334 77.5L67.2334 80.5667C64.8334 83 63.3334 85 63.3334 90H56.6667V88.3334C56.6667 84.6667 58.1667 81.3334 60.5667 78.9L64.7001 74.7C65.9334 73.5 66.6667 71.8334 66.6667 70C66.6667 66.3334 63.6667 63.3334 60.0001 63.3334C56.3334 63.3334 53.3334 66.3334 53.3334 70H46.6667C46.6667 62.6334 52.6334 56.6667 60.0001 56.6667C67.3667 56.6667 73.3334 62.6334 73.3334 70C73.3334 72.9334 72.1334 75.6 70.2334 77.5Z",
    fill: "#1A237E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.725076551179667c2dde7d0d6d16cc82.svg";
export { ForwardRef as ReactComponent };